// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5e05b48c","455":"569c793e"}[chunkId] + ".chunk.js";
};